export function logError(err: unknown) {
  // eslint-disable-next-line no-console
  console.error(err);
}
